import { useState } from "react";
import Btc from '../../assets/images/BTCPic.png'
export default function ImageWithLoader({ src, alt ,form=null,objectForm=null,base=Btc,rounded=""}) {

  const [loading, setLoading] = useState(true);

  return (
    <div className={`relative w-full h-full bg-gray-200  overflow-hidden ${form ? form : 'rounded-lg'}`}>
      {loading && (
        <img
           src={base}
           alt="Btc"
           className={`absolute  inset-0 w-full ${objectForm?objectForm:"object-cover"} h-full  blur-sm animate-pulse ${form ? form : 'rounded-lg'}`}
         />
      )}
      <img
        src={src}
        alt={alt}
        className={`w-full h-full object-contain transition-opacity  ${objectForm?objectForm:"object-cover"} duration-500 ${form ? form : 'rounded-lg'} ${
          loading ? "opacity-0" : "opacity-100"
        }`}
        onLoad={() => setLoading(false)}
      />
    </div>
  );
}
